import { createFileRoute } from "@tanstack/react-router";
import { GrowthAcceleratorPage } from "@/app/connect/pages/growth-accelerator";

export type GrowthAcceleratorSearchParams = {
	provider_id?: number;
	locality_id?: number;
	country_id?: number;
};

function parseNumber(value: unknown): number | undefined {
	if (typeof value === "number") return value;
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		const num = Number(cleaned);
		return Number.isFinite(num) ? num : undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/growth-accelerator")({
	validateSearch: (
		search: Record<string, unknown>,
	): GrowthAcceleratorSearchParams => ({
		provider_id: parseNumber(search.provider_id),
		locality_id: parseNumber(search.locality_id),
		country_id: parseNumber(search.country_id),
	}),
	component: GrowthAcceleratorPage,
});
